module.exports = __webpack_public_path__ + "img/p19.c92ddafe.png";